import React, { useEffect, useRef, useState } from 'react';
import { Dialog, DialogContent, Typography, Button } from '@material-ui/core';
import { Html5Qrcode } from 'html5-qrcode';

const QRScanner = ({ open, onClose, onResult }) => {
    const html5QrCodeRef = useRef(null);
    const scannerActivoRef = useRef(false); // bandera real
    const [scannerActivo, setScannerActivo] = useState(false); // solo para render (opcional)

    useEffect(() => {
        if (!open) return;

        const config = { fps: 10, qrbox: 250 };

        const timeout = setTimeout(() => {
            const qrRegion = document.getElementById('qr-reader');
            if (!qrRegion) return;

            html5QrCodeRef.current = new Html5Qrcode('qr-reader');

            html5QrCodeRef.current
                .start(
                    { facingMode: 'environment' },
                    config,
                    (decodedText) => {
                        if (decodedText.includes('dashport.run')) {
                            const url = decodedText;
                            const urlObj = new URL(url);
                            const registryFromUrl = urlObj.searchParams.get('registry');
                            detenerScanner(() => {
                                onResult(registryFromUrl);
                                onClose();
                            });
                        }
                    },
                    () => { }
                )
                .then(() => {
                    scannerActivoRef.current = true;
                    setScannerActivo(true);
                })
                .catch((err) => console.error('Error iniciando escáner:', err));
        }, 300);

        return () => {
            clearTimeout(timeout);
            detenerScanner();
        };
    }, [open]);

    const detenerScanner = (callback) => {
        if (html5QrCodeRef.current && scannerActivoRef.current) {
            html5QrCodeRef.current
                .stop()
                .then(() => {
                    html5QrCodeRef.current.clear();
                    scannerActivoRef.current = false;
                    setScannerActivo(false);
                    if (callback) callback();
                })
                .catch((err) => {
                    console.warn('Error al detener escáner:', err);
                    // aún así intentamos limpiar
                    try {
                        html5QrCodeRef.current.clear();
                    } catch (e) {
                        console.error('Error limpiando escáner luego del fallo en stop:', e);
                    }
                    scannerActivoRef.current = false;
                    setScannerActivo(false);
                    if (callback) callback();
                });
        } else if (html5QrCodeRef.current) {
            try {
                html5QrCodeRef.current.clear();
            } catch (e) {
                console.error('Error limpiando escáner sin iniciar (probablemente start no completó):', e);
            }
            scannerActivoRef.current = false;
            setScannerActivo(false);
            if (callback) callback();
        }
    };

    return (
        <Dialog open={open} onClose={() => detenerScanner(onClose)} maxWidth="md" fullWidth>
            <DialogContent>
                <Typography variant="h6" align="center" gutterBottom>
                    Escanea el código QR del atleta
                </Typography>
                <div
                    id="qr-reader"
                    style={{
                        width: '100%',
                        maxWidth: '400px',
                        margin: '0 auto',
                        padding: '8px',
                    }}
                />
                <Button
                    onClick={() => detenerScanner(onClose)}
                    color="secondary"
                    variant="outlined"
                    style={{ marginTop: 16, display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                >
                    Cerrar
                </Button>
            </DialogContent>
        </Dialog>
    );
};

export default QRScanner;
